/* Project Import will be here */
import { getSimilarProductsApi } from "../services/products";
import {
  getErrorObject,
  normalizeByGroup,
  mergeMultipleSchemeProducts
} from "../utilities/utils";
import { ISimilarProductsParams } from "models/productModels";
/* Project Import will be here */

export const types = {
  SIMILAR_PRODUCTS_REQUEST: "SIMILAR_PRODUCTS/SIMILAR_PRODUCTS_REQUEST",
  SIMILAR_PRODUCTS_SUCCESS: "SIMILAR_PRODUCTS/SIMILAR_PRODUCTS_SUCCESS",
  SIMILAR_PRODUCTS_FAILURE: "SIMILAR_PRODUCTS/SIMILAR_PRODUCTS_FAILURE",
  SIMILAR_PRODUCT_UPDATE_IS_FAV: "SIMILAR_PRODUCTS/SIMILAR_PRODUCT_UPDATE_IS_FAV"
};

const initialState = {
  groupIds: [],
  group: {},
  isLoading: false,
  ids: [],
  data: {},
  count: null,
  error: null
};

export const similarProducts = (state = initialState, action) => {
  switch (action.type) {
    case types.SIMILAR_PRODUCTS_REQUEST: {
      return {
        ...initialState,
        isLoading: true
      };
    }
    case types.SIMILAR_PRODUCTS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isLoading: false
      };
    case types.SIMILAR_PRODUCTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    case types.SIMILAR_PRODUCT_UPDATE_IS_FAV:
      let { ProductId, IsFavourite } = action.payload;
      if (ProductId in state.data) {
        return {
          ...state,
          data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
          error: null,
          isLoading: false
        }
      }
      else {
        return state;
      }
    default:
      return state;
  }
};

/* Get similar products of the selected product */
export const getSimilarProducts = (productId: number) => {
  return async (dispatch, getState) => {
    /* Make new request */
    dispatch({ type: types.SIMILAR_PRODUCTS_REQUEST });
    try {
      /* Get the scheme product for hot deals */
      const requestObject: ISimilarProductsParams = {
        Page: 1,
        Ids: [productId],
        FilterLevelCode: "SUCAT",
        Sorting: getState().appSettings.defaultProductSorting
      };
      const response = await getSimilarProductsApi(requestObject);

      /* Merge the multi scheme products */
      const schemeProductList = mergeMultipleSchemeProducts(response.data.Data);

      let payload = normalizeByGroup({
        data: schemeProductList,
        key: "ProductId",
        groupKey: "GroupId"
      });
      payload.count = schemeProductList.length;

      dispatch({
        type: types.SIMILAR_PRODUCTS_SUCCESS,
        payload
      });
    }
    catch (error) {
      dispatch(promiseCatchBlock(error, types.SIMILAR_PRODUCTS_FAILURE));
    }
  };
};

const promiseCatchBlock = (error: any, type: string) => {
  return (dispatch) => {
    const { message } = getErrorObject(error);
    dispatch({ type: type, payload: { error: message } });
  }
};